// extracted by mini-css-extract-plugin
export default {"tooltip":"bZGIV__tooltip","contentWrapper":"kxVAi__contentWrapper","contentLink":"eWWqo__contentLink"};